import { prepareOptionalRuntime } from '@Pages/pageRuntime/prepareOptionalRuntime';
import React, { Suspense } from 'react';

/**
 * A page reaches a shared component through `Sdk.Custom`, not through the
 * renderer that already suspended for the page's own optional chunks, so the
 * component has to ask for the ones its own source needs.
 *
 * The wait stays inside the shared component's own boundary. Without it the
 * nearest boundary is the renderer's page-wide one, whose blank fallback hides
 * the whole page the first time a late-mounted shared component loads a chunk.
 */
export function withOptionalRuntime(
  Component: React.ComponentType,
  source: string
): React.ComponentType {
  function OptionalRuntimeComponent(props: Record<string, unknown>) {
    'use memo';

    prepareOptionalRuntime([source]);

    return <Component {...props} />;
  }

  return function SharedComponent(props) {
    'use memo';

    return (
      <Suspense fallback={null}>
        <OptionalRuntimeComponent {...props} />
      </Suspense>
    );
  };
}
